"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _creatApp = require("@/api/creatApp");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    appId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      rules: {
        name: [{
          required: true,
          message: '请输入APP名称',
          trigger: 'blur'
        }],
        shortCode: [{
          required: true,
          message: '请输入APP短码',
          trigger: 'blur'
        }],
        // appBaseUrl: [
        //   { required: true, message: '请输入APP域名', trigger: 'blur' }
        // ],
        uniAppId: [{
          required: true,
          message: '请输入uni-app应用标识(AppId)',
          trigger: 'blur'
        }],
        agent: [{
          required: true,
          message: '请选择APP模式',
          trigger: 'change'
        }],
        inviteConfig: [{
          required: true,
          message: '请选择邀请码是否填写',
          trigger: 'change'
        }],
        icon: [{
          required: true,
          message: '请上传APP图标',
          trigger: 'change'
        }]
      },
      ruleForm: {
        name: '',
        shortCode: '',
        // appBaseUrl: '',
        uniAppId: '',
        appNo: '',
        agent: '',
        inviteConfig: '',
        icon: '',
        universalLinks: '',
        iosAppLinks: ''
      },
      // 管理员信息
      Administrator: {
        administratorName: '',
        administratorPhone: '',
        administratorStatus: ''
      }
    };
  },
  mounted: function mounted() {
    this.onQueryTenantDetail();
  },
  methods: {
    onQueryTenantDetail: function onQueryTenantDetail() {
      var _this = this;
      if (this.appId !== 0) {
        (0, _creatApp.queryTenantDetail)({
          appId: this.appId
        }).then(function (res) {
          _this.ruleForm.name = res.data.name;
          _this.ruleForm.shortCode = res.data.shortCode;
          // this.ruleForm.appBaseUrl = res.data.appBaseUrl
          _this.ruleForm.uniAppId = res.data.uniAppId;
          _this.ruleForm.appNo = res.data.appNo;
          _this.ruleForm.agent = res.data.agent;
          _this.ruleForm.inviteConfig = res.data.inviteConfig;
          _this.ruleForm.icon = res.data.icon;
          _this.ruleForm.universalLinks = res.data.universalLinks;
          _this.ruleForm.iosAppLinks = res.data.iosAppLinks;
          _this.Administrator.administratorName = res.data.administratorName;
          _this.Administrator.administratorPhone = res.data.administratorPhone;
          _this.Administrator.administratorStatus = res.data.administratorStatus;
        });
      }
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm[val] = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认编辑APP配置信息？', '提示').then(function (_) {
            (0, _creatApp.updateConfig)({
              appId: _this2.appId,
              name: _this2.ruleForm.name,
              uniAppId: _this2.ruleForm.uniAppId,
              agent: _this2.ruleForm.agent,
              inviteConfig: _this2.ruleForm.inviteConfig,
              icon: _this2.ruleForm.icon,
              universalLinks: _this2.ruleForm.universalLinks,
              iosAppLinks: _this2.ruleForm.iosAppLinks
            }).then(function (res) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              if (_this2.appId === 0) {
                _this2.$emit('change-value', res.data);
                _this2.$router.replace({
                  path: '/systemAdministrator/creatApp/appDetail',
                  query: {
                    id: "".concat(res.data)
                  }
                });
              } else {
                _this2.onQueryTenantDetail();
              }
            });
          }).catch(function (_) {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};